import { loadScript } from '@ifeng/ui_base';

// 去除空格
const trim = (str, is_global) => {
    let result = '';

    result = str.replace(/(^\s+)|(\s+$)/g, '');
    if (is_global.toLowerCase() === 'g') {
        result = result.replace(/\s/g, '');
    }

    return result;
};

/**
 * 一维数组转二维数组
 */
const oneChangeTwoDimensional = (arr, num) => {
    const result = [];

    for (let i = 0, len = arr.length; i < len; i += num) {
        const item = arr.slice(i, i + num);

        result.push(item);
    }

    return result;
};

/**
 * 解析广告信息，返回广告回调方法
 * @param { Object } ad
 */
const handleAd = async ad => {
    let callbackFn = null;

    try {
        if (ad.preload) {
            let list = [];
            let index = 0;

            if (typeof ad.preload === 'string') {
                list = [ad.preload];
            } else {
                list = ad.preload;
            }

            while (list.length > index) {
                const scriptUrl = list[index];

                console.log('load', scriptUrl);

                await loadScript(scriptUrl, { cache: false, reload: false });
                ++index;
            }
        }

        callbackFn = new Function(`return ${ad.callback}`)();
    } catch (error) {
        error.message = `AdError - ${error.message}`;

        console.error(error);
        console.error('AdError - AdData', ad);

        if (window && window.BJ_REPORT) window.BJ_REPORT.report(error);
    }

    return callbackFn;
};

/**
 * 格式化Moka职位地点列表
 * @param {*} locations
 */
const formatMokaLocations = locations => {
    const locationList = [{ value: '', label: '不限' }];

    locations.forEach(item => {
        if (item.locationRows && item.locationRows.length && item.locationRows[0] && item.locationRows[0].id) {
            locationList.push({ value: item.locationRows[0].id, label: item.label });
        }
    });

    return locationList;
};

/**
 * 格式化Moka职位地点列表
 * @param {*} zhinengs
 */
const formatMokaZhiNengs = zhinengs => {
    const zhiNengList = [{ value: '', label: '不限' }];

    zhinengs.forEach(item => {
        if (item.id) {
            zhiNengList.push({ value: item.id, label: item.label });
        }
    });

    return zhiNengList;
};

export { trim, oneChangeTwoDimensional, handleAd, formatMokaLocations, formatMokaZhiNengs };
